module.exports = __webpack_public_path__ + "static/media/rocket_flame2.77ad5134.gif";